// extracted by mini-css-extract-plugin
export default {"spinner":"spinner__2BgFs","sm":"sm__m8RZ6","md":"md__2QNGH","lg":"lg__1SA8v"};